const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = 'myraai_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export function formatDetail(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  if (detail && typeof detail === 'object') return detail.reason || detail.detail || detail.error || JSON.stringify(detail);
  return String(detail);
}

export async function api(path, { method = 'GET', body, isForm = false } = {}) {
  const token = getToken();
  const headers = {};
  if (!isForm) headers['Content-Type'] = 'application/json';
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: isForm ? body : body != null ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let json = null;
  try { json = text ? JSON.parse(text) : null; } catch { json = { detail: text }; }
  if (!res.ok) {
    const err = new Error(formatDetail(json && json.detail));
    err.status = res.status;
    err.data = json;
    throw err;
  }
  return json;
}

// Build a served-file URL that works inside <img> tags (uses ?token=).
export function fileUrl(relUrl) {
  if (!relUrl) return '';
  const token = getToken();
  const base = relUrl.startsWith('http') ? relUrl : `${BACKEND_URL}${relUrl}`;
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}token=${token}`;
}
